export default __webpack_public_path__ + "media/landscape/logo_vodafone-cfc53c9b.svg";